module.exports = __webpack_public_path__ + "img/bone-in.3435d8e8.png";